import { Component, EventEmitter, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { AdminAuthService } from "src/app/services/adminauth.service";
import { SERVERRESPONSERESULT } from "src/app/models/serverresponse";

/**
 * The admin login, with a backoffice account: username and password, then the 6-digit
 * two-factor code when the server asks for it. The server also asks for a code after a wrong
 * password, so the form never tells which part was wrong. Emits `loggedIn` once the session is
 * open.
 */
@Component({
  selector: "hkt-adminloginform",
  templateUrl: "./adminloginform.component.html",
})
export class AdminLoginFormComponent {
  @Output() loggedIn: EventEmitter<void> = new EventEmitter<void>();

  form: FormGroup;
  askCode: boolean = false;
  busy: boolean = false;
  error: string = "";

  constructor(private adminAuthService: AdminAuthService, fb: FormBuilder) {
    this.form = fb.group({
      user: ["", [Validators.required]],
      password: ["", [Validators.required]],
      code: [""],
    });
  }

  get canSubmit(): boolean {
    return this.form.valid && !this.busy && (!this.askCode || this.form.value.code.trim() != "");
  }

  onSubmit(): void {
    if (!this.canSubmit) {
      return;
    }
    const values = this.form.value;
    this.busy = true;
    this.error = "";
    this.adminAuthService.login(values.user, values.password, this.askCode ? values.code.trim() : "").subscribe(
      response => {
        this.busy = false;
        if (response.result == SERVERRESPONSERESULT.OK) {
          if (response.askCode) {
            this.askCode = true;
            return;
          }
          this.loggedIn.emit();
          return;
        }
        // As the backoffice does, a refusal starts again from the password
        this.error = response.error || "Error connecting to the server";
        this.askCode = false;
        this.form.patchValue({ code: "" });
      },
      err => {
        console.error(err);
        this.busy = false;
        this.error = "Error connecting to the server";
      },
    );
  }
}
